import { __decorate } from "tslib";
import readyState from 'ready-state';
import { observable } from '@slickdeals/durango/dist/javascript/decorators/observable';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import DataLayer, { Layout } from '@slickdeals/blueprint-twig/javascript/utilities/dataLayer';
/** The name of the module */
export const name = 'DealDetailsPageOutClickObservable';
/** The event name fired by this observable */
export const eventName = 'deal_details_page_outclick';
let DealDetailsPageOutClickObservable = class DealDetailsPageOutClickObservable {
    /**
       * Create an Observable instance
       */
    constructor() {
        // When dom is ready, add event listeners.
        readyState.domready.then(this.init.bind(this));
    }
    /**
       * Add event listeners to deal links, which call notify() on click.
       */
    init() {
        document.querySelectorAll('div [data-action-type="see-deal"] > a, a[data-link="dealDetail:Description Link"]:not([data-product-exitwebsite="slickdeals.net"])').forEach((item) => {
            item.addEventListener('click', this.onClick.bind(this));
        });
    }
    onClick() {
        const data = {
            threadid: null,
            layout: null,
            mobile: null,
        };
        DataLayer.get('product')
            .then(productData => {
            data.threadid = productData.threadId;
            return DataLayer.get('visitor');
        })
            .then(visitorData => {
            data.layout = visitorData.layout;
            data.mobile = visitorData.layout === Layout.MobileWeb || visitorData.layout === Layout.WebView;
        })
            .catch(reason => Logger.error(reason))
            .finally(() => {
            this.notify(data, eventName);
        });
    }
};
DealDetailsPageOutClickObservable = __decorate([
    observable
], DealDetailsPageOutClickObservable);
export default DealDetailsPageOutClickObservable;
